import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, Typography, Divider, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

export default function EditableList({
  itemId,
  primaryText,
  subtitleText,
  addDivider,
  handleEdit,
  handleDelete,
}) {
  return (
    <React.Fragment>
      <ListItem
        alignItems="flex-start"
        secondaryAction={
          <React.Fragment>
            <IconButton
              onClick={() => handleEdit(itemId)}
              size="small"
              edge="end"
              aria-label="edit"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => handleDelete(itemId)}
              size="small"
              edge="end"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </React.Fragment>
        }
      >
        <ListItemText
          primary={
            <Typography
              sx={{ display: 'block' }}
              component="span"
              variant="formTitle"
              color="text.primary"
            >
              {primaryText}
            </Typography>
          }
          secondary={
            <Typography
              sx={{ fontSize: '0.7rem', display: 'inline' }}
              component="span"
              variant="formTitle"
            >
              {subtitleText}
            </Typography>
          }
        />
      </ListItem>
      {addDivider && <Divider sx={{ marginLeft: 0 }} variant="inset" component="li" />}
    </React.Fragment>
  );
}

EditableList.propTypes = {
  itemId: PropTypes.number,
  primaryText: PropTypes.string,
  subtitleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  addDivider: PropTypes.bool,
  handleEdit: PropTypes.func,
  handleDelete: PropTypes.func,
};
